import { ACTIVITY_STATUS, WORKSHOP_BENCHMARK_IDS } from 'a/hub/data/constants';

const { IDLE, CALL_TO_ACTION, FINISHED, REWARD, INACTIVE } = ACTIVITY_STATUS;

const normalOnboardingSteps = [
  {
    step: 0,
    nextStep: 1,
    description: 'intro sequence',
    battery: INACTIVE,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: 'intro',
    loginTextId: 'login_onboarding_intro',
    targetActivityId: '',
  },
  {
    step: 1,
    nextStep: 2,
    description: 'prompt for 1st game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_1',
    targetActivityId: 'skill_game_1',
  },
  {
    step: 2,
    nextStep: 3,
    description: '1st game completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: 'firstGameMastered',
    loginTextId: 'login_onboarding_skill_game_1_complete',
    targetActivityId: '',
  },
  {
    step: 3,
    nextStep: 4,
    description: 'transmitter message for 1st game completed, prompt for 2nd game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_2',
    targetActivityId: 'skill_game_2',
  },
  {
    step: 4,
    nextStep: 5,
    description: '2nd game completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: 'secondGameMastered',
    loginTextId: 'login_onboarding_skill_game_2_complete',
    targetActivityId: '',
  },
  {
    // transmitter message for 2nd game completed, prompt for 1st vocab
    step: 5,
    nextStep: 6,
    description: 'transmitter message for 2nd game completed, prompt for 1st vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_1',
    targetActivityId: 'vocabulary_1',
  },
  {
    // 1st vocab completed, prompt for transmitter message
    step: 6,
    nextStep: 7,
    description: '1st vocab completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 1,
    loginTextId: 'login_vocabulary_1_complete_transmission',
    targetActivityId: '',
  },
  {
    // 1st vocab transmitter message finished, prompt for 3rd game
    step: 7,
    nextStep: 8,
    description: '1st vocab transmitter message finished, prompt for 3rd game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_3',
    targetActivityId: 'skill_game_3',
  },
  {
    // 3rd game completed, battery finished, prompt for TFE
    step: 8,
    nextStep: 9,
    description: '3rd game completed, battery finished, prompt for TFE',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1',
    targetActivityId: 'close_reading_1',
  },
  {
    // TFE completed, show TFE reward
    step: 9,
    nextStep: 10,
    description: 'TFE completed, show TFE reward',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: REWARD,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1_reward',
    targetActivityId: '',
  },
  {
    // TFE reward collected, prompt for curioso selection
    step: 10,
    nextStep: 11,
    description: 'TFE reward collected, prompt for curioso selection',
    battery: FINISHED,
    transmitter: INACTIVE,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    resetCurioso: true,
    loginTextId: 'login_onboarding_close_reading_1_curioso',
    targetActivityId: '',
  },
  {
    // curioso selected, prompt for 2nd vocab
    step: 11,
    nextStep: 12,
    description: 'curioso selected, prompt for 2nd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_2',
    targetActivityId: 'vocabulary_2',
  },
  {
    // 2nd vocab completed, prompt for transmitter message
    step: 12,
    nextStep: 13,
    description: '2nd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 2,
    loginTextId: 'login_vocabulary_2_complete_transmission',
    targetActivityId: '',
  },
  {
    // 2nd transmitter message completed, prompt for eReader
    step: 13,
    nextStep: 14,
    description: '2nd transmitter message completed, prompt for eReader',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: FINISHED,
    eReader: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1',
    targetActivityId: 'ereader_1',
  },
  {
    // eReader completed, show eReader reward
    step: 14,
    nextStep: 15,
    description: 'eReader completed, show eReader reward',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: FINISHED,
    eReader: REWARD,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1_reward',
    targetActivityId: '',
  },
  {
    // eReader reward earned, eReader finished, prompt for 3rd vocab
    step: 15,
    nextStep: 16,
    description: 'eReader reward earned, eReader finished, prompt for 3rd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_3',
    targetActivityId: 'vocabulary_3',
  },
  {
    // 3rd vocab completed, prompt for transmitter message
    step: 16,
    nextStep: 17,
    description: '3rd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 3,
    loginTextId: 'login_vocabulary_3_complete_transmission',
    targetActivityId: '',
  },
  {
    // 3rd transmitter message completed, quest complete
    step: 17,
    nextStep: 0,
    description: '3rd transmitter message completed, quest complete',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_onboarding_quest_complete',
    targetActivityId: '',
  },
];

const normalSteps = [
  // start, prompt for 1st game
  {
    step: 0,
    nextStep: 1,
    description: 'start, prompt for 1st game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_1',
    targetActivityId: 'skill_game_1',
  },
  {
    // 1st game completed, prompt for 2nd game
    step: 1,
    nextStep: 2,
    description: '1st game completed, prompt for 2nd game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_2',
    targetActivityId: 'skill_game_2',
  },
  {
    // 2nd game completed, prompt for 1st vocab
    step: 2,
    nextStep: 3,
    description: '2nd game completed, prompt for 1st vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_1',
    targetActivityId: 'vocabulary_1',
  },
  {
    // 1st vocab completed, prompt for transmitter message
    step: 3,
    nextStep: 4,
    description: '1st vocab completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 1,
    loginTextId: 'login_vocabulary_1_complete_transmission',
    targetActivityId: '',
  },
  {
    // 1st vocab transmitter message finished, prompt for 3rd game
    step: 4,
    nextStep: 5,
    description: '1st vocab transmitter message finished, prompt for 3rd game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_3',
    targetActivityId: 'skill_game_3',
  },
  {
    // 3rd game completed, battery finished, prompt for TFE
    step: 5,
    nextStep: 6,
    description: '3rd game completed, battery finished, prompt for TFE',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1',
    targetActivityId: 'close_reading_1',
  },
  {
    // TFE completed, show TFE reward
    step: 6,
    nextStep: 7,
    description: 'TFE completed, show TFE reward',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: REWARD,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1_reward',
    targetActivityId: '',
  },
  {
    // prompt for 2nd vocab
    step: 7,
    nextStep: 8,
    description: 'prompt for 2nd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_2',
    targetActivityId: 'vocabulary_2',
  },
  {
    // 2nd vocab completed, prompt for transmitter message
    step: 8,
    nextStep: 9,
    description: '2nd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 2,
    loginTextId: 'login_vocabulary_2_complete_transmission',
    targetActivityId: '',
  },
  {
    // 2nd transmitter message completed, prompt for eReader
    step: 9,
    nextStep: 10,
    description: '2nd transmitter message completed, prompt for eReader',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: FINISHED,
    eReader: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1',
    targetActivityId: 'ereader_1',
  },
  {
    // eReader completed, show eReader reward
    step: 10,
    nextStep: 11,
    description: 'eReader completed, show eReader reward',
    battery: FINISHED,
    transmitter: IDLE,
    TFE: FINISHED,
    eReader: REWARD,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1_reward',
    targetActivityId: '',
  },
  {
    // eReader reward earned, eReader finished, prompt for 3rd vocab
    step: 11,
    nextStep: 12,
    description: 'eReader reward earned, eReader finished, prompt for 3rd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_3',
    targetActivityId: 'vocabulary_3',
  },
  {
    // 3rd vocab completed, prompt for transmitter message
    step: 12,
    nextStep: 13,
    description: '3rd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 3,
    loginTextId: 'login_vocabulary_3_complete_transmission',
    targetActivityId: '',
  },
  {
    // 3rd transmitter message completed, quest complete
    step: 13,
    nextStep: 0,
    description: '3rd transmitter message completed, quest complete',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_quest_complete',
    targetActivityId: '',
  },
];

const wellBelowOnboardingSteps = [
  {
    // quest start
    step: 0,
    nextStep: 1,
    description: 'quest start',
    TFE: INACTIVE,
    transmitter: INACTIVE,
    eReader: INACTIVE,
    battery: INACTIVE,
    transmissionSequenceId: 'intro',
    loginTextId: 'login_onboarding_intro',
    targetActivityId: '',
  },
  // intro finished, prompt for 1st game
  {
    step: 1,
    nextStep: 2,
    description: 'intro finished, prompt for 1st game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_1',
    targetActivityId: 'skill_game_1',
  },
  {
    // 1st game complete, prompt for transmitter message
    step: 2,
    nextStep: 3,
    description: '1st game complete, prompt for transmitter message',
    TFE: INACTIVE,
    transmitter: CALL_TO_ACTION,
    eReader: INACTIVE,
    battery: IDLE,
    transmissionSequenceId: 'firstGameMastered',
    loginTextId: 'login_onboarding_skill_game_1_complete',
    targetActivityId: '',
  },
  {
    // transmission for 1st game complete, prompt for 2nd game
    step: 3,
    nextStep: 4,
    description: 'transmission for 1st game complete, prompt for 2nd game',
    TFE: INACTIVE,
    transmitter: INACTIVE,
    eReader: INACTIVE,
    battery: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_2',
    targetActivityId: 'skill_game_2',
  },
  {
    // 2nd game complete, prompt for transmitter message
    step: 4,
    nextStep: 5,
    description: '2nd game complete, prompt for transmitter message',
    TFE: INACTIVE,
    transmitter: CALL_TO_ACTION,
    eReader: INACTIVE,
    battery: IDLE,
    transmissionSequenceId: 'secondGameMastered',
    loginTextId: 'login_onboarding_skill_game_2_complete',
    targetActivityId: '',
    fullBattery: true,
  },
  {
    // transmitter message for 2nd game completed, prompt for 1st vocab
    step: 5,
    nextStep: 6,
    description: 'transmitter message for 2nd game completed, prompt for 1st vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_1',
    targetActivityId: 'vocabulary_1',
    fullBattery: true,
  },
  {
    // 1st vocab completed, prompt for transmitter message
    step: 6,
    nextStep: 7,
    description: '1st vocab completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 1,
    loginTextId: 'login_vocabulary_1_complete_transmission',
    targetActivityId: '',
    fullBattery: true,
  },
  {
    // 1st vocab transmitter message finished, prompt for 1st TFE
    step: 7,
    nextStep: 8,
    description: '1st vocab transmitter message finished, prompt for 1st TFE',
    battery: IDLE,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1',
    targetActivityId: 'close_reading_1',
    fullBattery: true,
  },
  {
    // 1st TFE complete, prompt for 3rd game
    step: 8,
    nextStep: 9,
    description: '1st TFE complete, prompt for 3rd game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_3',
    targetActivityId: 'skill_game_3',
  },
  {
    // 3rd game complete, prompt for 4th game
    step: 9,
    nextStep: 10,
    description: '3rd game complete, prompt for 4th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_4',
    targetActivityId: 'skill_game_4',
  },
  {
    // 4th game complete, prompt 2nd vocab
    step: 10,
    nextStep: 11,
    description: '4th game complete, prompt 2nd vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_2',
    targetActivityId: 'vocabulary_2',
    fullBattery: true,
  },
  {
    // 2nd vocab completed, prompt for transmitter message
    step: 11,
    nextStep: 12,
    description: '2nd vocab completed, prompt for transmitter message',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 2,
    loginTextId: 'login_vocabulary_2_complete_transmission',
    targetActivityId: '',
    fullBattery: true,
  },
  {
    // 2nd vocab complete, prompt 2nd TFE
    step: 12,
    nextStep: 13,
    description: '2nd vocab complete, prompt 2nd TFE',
    battery: IDLE,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_2',
    targetActivityId: 'close_reading_2',
    fullBattery: true,
  },
  {
    // 2nd TFE complete, prompt 5th game
    step: 13,
    nextStep: 14,
    description: '2nd TFE complete, prompt 5th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_5',
    targetActivityId: 'skill_game_5',
  },
  {
    // 5th game complete, prompt 6th game
    step: 14,
    nextStep: 15,
    description: '5th game complete, prompt 6th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_6',
    targetActivityId: 'skill_game_6',
  },
  {
    // 6th game complete, prompt 3rd vocab
    step: 15,
    nextStep: 16,
    description: '6th game complete, prompt 3rd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_3',
    targetActivityId: 'vocabulary_3',
  },
  {
    // 3rd vocab completed, prompt for transmitter message
    step: 16,
    nextStep: 17,
    description: '3rd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 3,
    loginTextId: 'login_vocabulary_3_complete_transmission',
    targetActivityId: '',
  },
  {
    // 3rd vocab complete, prompt 3rd TFE
    step: 17,
    nextStep: 18,
    description: '3rd vocab complete, prompt 3rd TFE',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_3',
    targetActivityId: 'close_reading_3',
  },
  {
    // 3rd TFE complete, show reward
    step: 18,
    nextStep: 19,
    description: '3rd TFE complete, show reward',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: REWARD,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1_reward',
    targetActivityId: '',
  },
  {
    // TFE reward collected, prompt for curioso selection
    step: 19,
    nextStep: 20,
    description: 'TFE reward collected, prompt for curioso selection',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    resetCurioso: true,
    loginTextId: 'login_onboarding_close_reading_3_curioso',
    targetActivityId: '',
  },
  {
    // curioso selected, prompt for eReader
    step: 20,
    nextStep: 21,
    description: 'curioso selected, prompt for eReader',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1',
    targetActivityId: 'ereader_1',
  },
  {
    // eReader complete, show reward
    step: 21,
    nextStep: 22,
    description: 'eReader complete, show reward',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: REWARD,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1_reward',
    targetActivityId: '',
  },
  {
    // Quest Complete
    step: 22,
    nextStep: 0,
    description: 'TFE reward earned, TFE finished, prompt ereader',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_onboarding_quest_complete',
    targetActivityId: '',
  },
];

const wellBelowSteps = [
  // prompt for 1st game
  {
    step: 0,
    nextStep: 1,
    description: 'prompt for 1st game',
    battery: CALL_TO_ACTION,
    transmitter: INACTIVE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_1',
    targetActivityId: 'skill_game_1',
  },
  {
    // prompt for 2nd game
    step: 1,
    nextStep: 2,
    description: 'prompt for 2nd game',
    TFE: INACTIVE,
    transmitter: INACTIVE,
    eReader: INACTIVE,
    battery: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_2',
    targetActivityId: 'skill_game_2',
  },
  {
    // prompt for 1st vocab
    step: 2,
    nextStep: 3,
    description: 'prompt for 1st vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_1',
    targetActivityId: 'vocabulary_1',
    fullBattery: true,
  },
  {
    // 1st vocab completed, prompt for transmitter message
    step: 3,
    nextStep: 4,
    description: '1st vocab completed, prompt for transmitter',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 1,
    loginTextId: 'login_vocabulary_1_complete_transmission',
    targetActivityId: '',
    fullBattery: true,
  },
  {
    // 1st vocab complete, prompt for 1st TFE
    step: 4,
    nextStep: 5,
    description: '1st vocab complete, prompt for 1st TFE',
    battery: IDLE,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1',
    targetActivityId: 'close_reading_1',
    fullBattery: true,
  },
  {
    // 1st TFE complete, prompt for 3rd game
    step: 5,
    nextStep: 6,
    description: '1st TFE complete, prompt for 3rd game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_3',
    targetActivityId: 'skill_game_3',
  },
  {
    // 3rd game complete, prompt for 4th game
    step: 6,
    nextStep: 7,
    description: '3rd game complete, prompt for 4th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_4',
    targetActivityId: 'skill_game_4',
  },
  {
    // 4th game complete, prompt 2nd vocab
    step: 7,
    nextStep: 8,
    description: '4th game complete, prompt 2nd vocab',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_2',
    targetActivityId: 'vocabulary_2',
    fullBattery: true,
  },
  {
    // 2nd vocab completed, prompt for transmitter message
    step: 8,
    nextStep: 9,
    description: '2nd vocab completed, prompt for transmitter',
    battery: IDLE,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 2,
    loginTextId: 'login_vocabulary_2_complete_transmission',
    targetActivityId: '',
    fullBattery: true,
  },
  {
    // 2nd vocab complete, prompt 2nd TFE
    step: 9,
    nextStep: 10,
    description: '2nd vocab complete, prompt 2nd TFE',
    battery: IDLE,
    transmitter: IDLE,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_2',
    targetActivityId: 'close_reading_2',
    fullBattery: true,
  },
  {
    // 2nd TFE complete, prompt 5th game
    step: 10,
    nextStep: 11,
    description: '2nd TFE complete, prompt 5th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_5',
    targetActivityId: 'skill_game_5',
  },
  {
    // 5th game complete, prompt 6th game
    step: 11,
    nextStep: 12,
    description: '5th game complete, prompt 6th game',
    battery: CALL_TO_ACTION,
    transmitter: IDLE,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_skill_game_6',
    targetActivityId: 'skill_game_6',
  },
  {
    // 6th game complete, prompt 3rd vocab
    step: 12,
    nextStep: 13,
    description: '6th game complete, prompt 3rd vocab',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: INACTIVE,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_vocabulary_3',
    targetActivityId: 'vocabulary_3',
  },
  {
    // 3rd vocab completed, prompt for transmitter message
    step: 13,
    nextStep: 14,
    description: '3rd vocab completed, prompt for transmitter message',
    battery: FINISHED,
    transmitter: CALL_TO_ACTION,
    TFE: IDLE,
    eReader: INACTIVE,
    transmissionSequenceId: 'vocabMastered',
    transmissionIndex: 3,
    loginTextId: 'login_vocabulary_3_complete_transmission',
    targetActivityId: '',
  },
  {
    // 3rd vocab complete, prompt 3rd TFE
    step: 14,
    nextStep: 15,
    description: '3rd vocab complete, prompt 3rd TFE',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: CALL_TO_ACTION,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_3',
    targetActivityId: 'close_reading_3',
  },
  {
    // 3rd TFE complete, show reward
    step: 15,
    nextStep: 16,
    description: '3rd TFE complete, show reward',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: REWARD,
    eReader: INACTIVE,
    transmissionSequenceId: null,
    loginTextId: 'login_close_reading_1_reward',
    targetActivityId: '',
  },
  {
    // TFE reward collected, TFE finished, prompt ereader
    step: 16,
    nextStep: 17,
    description: 'TFE reward collected, TFE finished, prompt ereader',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: CALL_TO_ACTION,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1',
    targetActivityId: 'ereader_1',
  },
  {
    // eReader complete, show reward
    step: 17,
    nextStep: 18,
    description: 'eReader complete, show reward',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: REWARD,
    transmissionSequenceId: null,
    loginTextId: 'login_ereader_1_reward',
    targetActivityId: '',
  },
  {
    // quest complete
    step: 18,
    nextStep: 0,
    description: 'Quest Complete',
    battery: FINISHED,
    transmitter: FINISHED,
    TFE: FINISHED,
    eReader: FINISHED,
    transmissionSequenceId: null,
    loginTextId: 'login_quest_complete',
    targetActivityId: '',
  },
];

const challengeStep = {
  step: 0,
  nextStep: 0,
  description: 'Challenge Quest',
  battery: FINISHED,
  transmitter: FINISHED,
  TFE: CALL_TO_ACTION,
  eReader: FINISHED,
  transmissionSequenceId: null,
  loginTextId: 'login_challenge',
  targetActivityId: 'challenge',
};

const endOfEverythingStep = {
  step: 0,
  nextStep: 0,
  description: 'End of All Quests and Challenges',
  battery: INACTIVE,
  transmitter: INACTIVE,
  TFE: CALL_TO_ACTION,
  eReader: INACTIVE,
  transmissionSequenceId: null,
  loginTextId: 'login_end_of_everything',
  targetActivityId: 'challenge',
};

const demoStep = {
  step: 0,
  nextStep: 0,
  description: 'Demo Quest',
  battery: CALL_TO_ACTION,
  transmitter: IDLE,
  TFE: IDLE,
  eReader: IDLE,
  transmissionSequenceId: null,
  loginTextId: 'login_onboarding_intro',
  targetActivityId: 'demo',
};

// eslint-disable-next-line import/prefer-default-export
export const wellBelowFlows = {
  standard: wellBelowSteps,
  onboarding: wellBelowOnboardingSteps,
  challenge: [challengeStep],
  endOfEverything: [endOfEverythingStep],
  demo: [demoStep],
};

export const normalFlows = {
  standard: normalSteps,
  onboarding: normalOnboardingSteps,
  challenge: [challengeStep],
  endOfEverything: [endOfEverythingStep],
  demo: [demoStep],
};

export const getWorkshopFlow = (benchmark, isOnboarding) => {
  const flows = benchmark === WORKSHOP_BENCHMARK_IDS.WELL_BELOW ? wellBelowFlows : normalFlows;
  return isOnboarding ? flows.onboarding : flows.standard;
};

/**
 * Gets the config for a specific step in the workshop flow based on step ID, benchmark ID and onboarding flag.
 * @param {number} step - The current step ID in the workshop flow.
 * @param {string} benchmarkId - The benchmark ID to determine the flow.
 * @param {boolean} isOnboarding - Indicates if the flow is for onboarding.
 * @returns {object} The configuration for the specified step.
 */
export const getWorkshopStepConfig = (step, benchmarkId, isOnboarding) => {
  const benchmarkFlow = benchmarkId === WORKSHOP_BENCHMARK_IDS.WELL_BELOW ? wellBelowFlows : normalFlows;
  const flowConfig = isOnboarding ? benchmarkFlow.onboarding : benchmarkFlow.standard;
  return flowConfig.find((config) => config.step === step);
};

export const fluencyStep = {
  description: 'fluency assignment active — transmitter call to action for fluency modal',
  transmitter: CALL_TO_ACTION,
  transmissionSequenceId: null,
};
